(function () {
  'use strict';

  if (window.__gizetGlobalCartV2) return;
  window.__gizetGlobalCartV2 = true;

  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  function updateCartUi(cart) {
    var count = Number(cart && cart.item_count || 0);

    document.querySelectorAll('[ref="cartBubbleCount"], [data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
      node.classList.toggle('hidden', count === 0);
    });

    document.querySelectorAll('.cart-bubble').forEach(function (node) {
      node.classList.toggle('visually-hidden', count === 0);
    });

    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (node) {
      node.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (_) {}

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'gizet-fast-cart',
        data: {
          itemCount: count,
          source: 'gizet-fast-cart',
          sections: {}
        }
      }
    }));
  }

  async function readJson(response) {
    var text = await response.text();
    if (!text) return {};
    try { return JSON.parse(text); } catch (_) { return { description: text }; }
  }

  async function addVariant(variantId, quantity) {
    var params = new URLSearchParams();
    params.set('id', String(variantId));
    params.set('quantity', String(quantity));

    var response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: params.toString()
    });

    var result = await readJson(response);
    if (!response.ok) {
      throw new Error(result.description || result.message || 'እቃውን ወደ ጋሪ መጨመር አልተቻለም።');
    }

    var cartResponse = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!cartResponse.ok) throw new Error('ጋሪውን ማዘመን አልተቻለም።');

    var cart = await cartResponse.json();
    updateCartUi(cart);
    return cart;
  }

  function setStatus(section, message, isError) {
    var status = section.querySelector('[data-gz-cart-status]');
    if (!status) return;
    status.classList.toggle('is-error', Boolean(isError));
    if (isError) status.textContent = message;
    else status.innerHTML = message;
  }

  async function addFromProductSection(section, button) {
    if (!section || section.dataset.gizetBusy === '1') return;

    var variantInput = section.querySelector('[data-gz-variant-input]');
    var quantityInput = section.querySelector('[data-gz-quantity]');
    var variantId = variantInput && variantInput.value;
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value || '1', 10) || 1);

    if (!variantId) {
      setStatus(section, 'እባክዎ አማራጭ ይምረጡ።', true);
      return;
    }

    section.dataset.gizetBusy = '1';
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'በመጨመር ላይ…';
    setStatus(section, '', false);

    try {
      await addVariant(variantId, quantity);
      button.textContent = 'ተጨምሯል ✓';
      setStatus(section, 'ወደ ጋሪ ተጨምሯል። <a href="' + root + 'cart">ጋሪውን ይክፈቱ</a>', false);
    } catch (error) {
      button.textContent = originalText;
      setStatus(section, error && error.message ? error.message : 'እባክዎ ድጋሚ ይሞክሩ።', true);
    } finally {
      section.dataset.gizetBusy = '0';
      window.setTimeout(function () {
        button.disabled = false;
        if (button.textContent === 'ተጨምሯል ✓') button.textContent = originalText;
      }, 1400);
    }
  }

  async function addFromForm(form, button) {
    if (!form || form.dataset.gizetBusy === '1') return;

    var idInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var variantId = idInput && idInput.value;
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value || '1', 10) || 1);
    if (!variantId) return;

    form.dataset.gizetBusy = '1';
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'በመጨመር ላይ…';
    }

    try {
      await addVariant(variantId, quantity);
      if (button) button.textContent = 'ተጨምሯል ✓';
    } catch (error) {
      window.alert(error && error.message ? error.message : 'እባክዎ ድጋሚ ይሞክሩ።');
      if (button) button.textContent = originalText;
    } finally {
      form.dataset.gizetBusy = '0';
      if (button) {
        window.setTimeout(function () {
          button.disabled = false;
          if (button.textContent === 'ተጨምሯል ✓') button.textContent = originalText;
        }, 1400);
      }
    }
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target && event.target.closest ? event.target.closest('[data-gz-add]') : null;
    if (addButton) {
      var section = addButton.closest('[data-gz-product-section]');
      if (!section) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addFromProductSection(section, addButton);
      return;
    }

    var thumb = event.target && event.target.closest ? event.target.closest('[data-gz-thumb]') : null;
    if (thumb) {
      var productSection = thumb.closest('[data-gz-product-section]');
      var mainImage = productSection && productSection.querySelector('[id^="GizetMainImage-"]');
      if (mainImage && thumb.dataset.image) mainImage.src = thumb.dataset.image;
      if (productSection) {
        productSection.querySelectorAll('[data-gz-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
      }
      thumb.classList.add('is-active');
    }
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest('[data-gz-variant-select]') : null;
    if (!select) return;

    var section = select.closest('[data-gz-product-section]');
    if (!section) return;

    var option = select.options[select.selectedIndex];
    var available = option.dataset.available === 'true';
    var variantInput = section.querySelector('[data-gz-variant-input]');
    var price = section.querySelector('[data-gz-price]');
    var image = section.querySelector('[id^="GizetMainImage-"]');
    var addButton = section.querySelector('[data-gz-add]');
    var orderButton = section.querySelector('.gizet-order-now');

    if (variantInput) variantInput.value = option.value;
    if (price) price.textContent = option.dataset.price || '';
    if (image && option.dataset.image) image.src = option.dataset.image;
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'ወደ ጋሪ ጨምር' : 'አሁን አይገኝም';
    }
    if (orderButton) {
      orderButton.disabled = !available;
      orderButton.dataset.variant = option.value;
      orderButton.dataset.price = option.dataset.price || '';
      orderButton.dataset.priceCents = option.dataset.priceCents || '';
      if (option.dataset.image) orderButton.dataset.image = option.dataset.image;
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-gizet-fast-cart], form[action*="/cart/add"]') : null;
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addFromForm(form, event.submitter || form.querySelector('button[type="submit"], input[type="submit"]'));
  }, true);
})();
